import * as React from 'react';
import { flow } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { IStore } from '../../../../redux/IStore';
import NavigationBar from '../../components/NavigationBar';
import {Col, Form, Row} from 'react-bootstrap';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import { actions as brandingActions } from '../../../../services/branding/reducer';
import { formValueSelector, InjectedFormProps, reduxForm} from 'redux-form';
import {IActivities, IChannel, IIAS, IIOBSP, IPremium, IProduct, QuoteStatus} from '../../../../data/api/models';
import {IAuthState} from '../../../../services/auth/models';
import {IBrandingActions, II18nMessages} from '../../../../services/branding/models';
import {IQuoteActions, IQuoteState} from '../../../../services/quote/models';
import DeclarationQuestions from '../../components/DeclarationQuestions';
import DeclinesAndReferrals from '../../components/DeclinesAndReferrals';
import moment = require('moment');
import {
  getAvailableQuote,
  getReferralsAndDeclines,
  PRODUCT_NAME,
  proRataFactor,
  displayCurrency,
} from '../../../../util/helpers';
import SaveQuoteModal from '../../components/SaveQuoteModal';
import Loading from '../../../../components/Loading';
import {isUndefined} from 'util';

interface IValidationFormProps extends InjectedFormProps {
  dispatch: any;
  auth: IAuthState;
  startDate: string;
  endDate: string;
  product: IProduct;
  renewal: boolean;
  channel: IChannel;
  i18n: II18nMessages;
  quote: IQuoteState;
  renderDefinition(name: string): any;
  actions: {
    quote: IQuoteActions;
    branding: IBrandingActions;
  };
  ias: IIAS;
  iobsp: IIOBSP;
  declaration: any;
  paymentSchedule: string;
  handleCalculate: any;
  activities: IActivities;
}

const POLICY_START_DATE_MAX_DAYS = process.env.APP_ENV !== 'production' ? 365 : 122;

class ValidationForm extends React.Component<IValidationFormProps, any> {
  public state = {
    declines: [],
    referrals: [],
    errors: [],
    gross: 0,
    scheduleOptions: [
      {label: 'Annuel', value: 'annual'},
    ],
    referred: false,
    isDeferredStartDate: false,
  };

  public componentDidMount() {
    const { quote, dispatch, change, renewal, handleCalculate, actions } = this.props;

    // restore bi-annual selection after save
    if (quote.application.paymentSchedule === 'bi-annual') {
      dispatch(change('recurringCard', true));
      dispatch(change('paymentType', 'recurring card'));
      this.setState({ scheduleOptions: [
        {label: 'Annuel', value: 'annual'},
        {label: 'Semestriel', value: 'bi-annual'},
      ]});
    }

    // move start date to today if in the past
    if (!renewal) {
      this.moveStartDate();
    }

    // check dates when renewal
    if (renewal) {
      this.setState({ scheduleOptions: [
        {label: 'Annuel', value: 'annual'},
        {label: 'Semestriel', value: 'bi-annual'},
      ]});

      handleCalculate().then(() => {
        actions.quote.getRcpDocPropositionAssurance(quote.application.id);
        if (quote.application.paymentSchedule !== 'bi-annual') {
          actions.quote.setBiAnnualFirstAmount(0.00);
        } else {
          actions.quote.getBiAnnualFirstAmount(quote.application.id);
        }
      });
    }
  }

  public componentWillReceiveProps(nextProps) {
    const {
      quote,
      actions,
      dispatch,
      change,
      handleCalculate,
      paymentSchedule,
      startDate,
      renewal,
    } = this.props;

    /* get proposition document */
    const oldPremiums: IPremium[] = quote.application.premiums;
    const newPremiums: IPremium[] = nextProps.quote.application.premiums;
    if (oldPremiums !== newPremiums && !oldPremiums.length && newPremiums.length) {
      actions.quote.getRcpDocPropositionAssurance(quote.application.id);
    }

    /* Check for change in start date to adjust payment schedule options */
    this.scheduleOptions(nextProps.startDate);

    /* Check for schedule change */
    const oldSchedule: string = quote.application.paymentSchedule;
    const newSchedule: string = nextProps.quote.application.paymentSchedule;
    if (oldSchedule !== newSchedule) {
      if (newSchedule === 'bi-annual') {
        dispatch(change('recurringCard', true));
        dispatch(change('paymentType', 'recurring card'));
      } else {
        dispatch(change('recurringCard', false));
        dispatch(change('paymentType', 'card'));
      }
    }

    /* Check for backdated start date and adjust end date */
    if (!renewal) {
      this.backdatedCover(nextProps.startDate);
    }
    const availableQuote = getAvailableQuote(quote);
    if (availableQuote.length) {
      dispatch(change('schemeId', availableQuote[0].scheme.id));

      if (this.state.gross !== availableQuote[0].gross) {
        this.setState({
          gross: availableQuote[0].gross,
        });
      }
    }

    const referralsAndDeclines = getReferralsAndDeclines(quote);
    if (JSON.stringify(this.state.declines) !== JSON.stringify(referralsAndDeclines.declines)) {
      this.setState({ declines: referralsAndDeclines.declines });
    }
    if (JSON.stringify(this.state.referrals) !== JSON.stringify(referralsAndDeclines.referrals)) {
      this.setState({ referrals: referralsAndDeclines.referrals });
      if (! this.state.referred && ! referralsAndDeclines.declines.length && referralsAndDeclines.referrals.length) {
        this.setState({ referred: true });
        actions.quote.referralQuote(
          quote.application.id, referralsAndDeclines.referrals,
        );
      }
    }
    if (JSON.stringify(this.state.errors) !== JSON.stringify(referralsAndDeclines.errors)) {
      this.setState({ errors: referralsAndDeclines.errors });
    }

    const nextStartDateNotEmpty = nextProps.startDate.length > 0;
    const dateChanged = startDate !== nextProps.startDate;

    /* Check for deferred start date and display alert */
    const nextYearMoment = moment().add(1, 'year').startOf('year');
    const startDateMoment = moment(nextProps.startDate, 'DD/MM/YYYY').startOf('day');
    if (!renewal && startDateMoment.isSame(nextYearMoment)) {
      this.setState({isDeferredStartDate: true});
    } else {
      this.setState({isDeferredStartDate: false});
    }

    if (referralsAndDeclines.empty
      && ((paymentSchedule !== nextProps.paymentSchedule) || dateChanged)) {

      handleCalculate().then(() => {
        if (dateChanged || nextStartDateNotEmpty) {
          actions.quote.getRcpDocPropositionAssurance(quote.application.id);
          if (nextProps.paymentSchedule !== 'bi-annual') {
            actions.quote.setBiAnnualFirstAmount(0.00);
          } else {
            actions.quote.getBiAnnualFirstAmount(quote.application.id);
          }
        }
      });
    }

  }

  private moveStartDate() {
    const { initialValues, dispatch, change } = this.props;

    const startDateMoment = moment(initialValues.startDate, 'DD/MM/YYYY');
    if (startDateMoment.isBefore(moment().startOf('day'))) {
      dispatch(change('startDate', moment().format('DD/MM/YYYY')));
    }
  }

  private backdatedCover(nextStartDate) {
    const { startDate, dispatch, change } = this.props;
    if (startDate === nextStartDate || startDate === undefined || nextStartDate === undefined) {
      return;
    }

    const newStartDate = moment(nextStartDate, 'DD/MM/YYYY');
    const dateFields = proRataFactor(newStartDate);

    if (nextStartDate.length === 0) {
      return;
    }

    dispatch(change('startDate', dateFields.startDate.format('DD/MM/YYYY')));
    dispatch(change('backdatedCover', dateFields.backdatedCover));
    dispatch(change('endDate', dateFields.endDate.format('DD/MM/YYYY')));
  }

  private scheduleOptions(nextStartDate) {
    const { startDate, dispatch, change } = this.props;
    if (startDate === nextStartDate || startDate === undefined || nextStartDate === undefined) {
      return;
    }

    const newStartDate = moment(nextStartDate, 'DD/MM/YYYY');

    if (newStartDate.month() <= 5) {
      this.setState({ scheduleOptions: [
        {label: 'Annuel', value: 'annual'},
        {label: 'Semestriel', value: 'bi-annual'},
      ]});
    } else {
      this.setState({ scheduleOptions: [
        {label: 'Annuel', value: 'annual'},
      ]});
      dispatch(change('paymentSchedule', 'annual'));
    }
  }

  private getQuestions() {
    const {ias, iobsp, quote, renewal, startDate} = this.props;
    const { isDeferredStartDate } = this.state;
    const questions = [];
    const allQuestions = {
      startDate: {
        field: 'startDate',
        question: 'Date d\'effet souhaitée ?<br />Si vous souhaitez souscrire à une date antérieure, ' +
          'merci de nous contacter à l’adresse suivante : ' +
          '<a href="mailto:rcpro.france@msamlin.com">rcpro.france@msamlin.com</a>',
        fieldType: 'date',
        minDate: renewal ? moment(startDate) : moment(),
        maxDate: renewal ? moment(startDate) : moment().add(POLICY_START_DATE_MAX_DAYS, 'days'),
        deferredStartDate: isDeferredStartDate,
        deferredStartDateMessage: 'Vous avez choisi une date d’effet au 1er janvier prochain' +
        ', vous serez débité automatiquement le 2 janvier',
      },
      paymentSchedule: {
        field: 'paymentSchedule',
        question: 'Fractionnement de la prime',
        fieldType: 'button-group',
        buttonWidth: 12,
        buttons: this.state.scheduleOptions,
      },
      1: {
        field: 'issueDeclaration[1]',
        question: 'J’ai pris connaissance de la proposition ' + quote.application.quoteReference +
          ', ' +
        'des Conventions Spéciales et ses Annexes, des Conditions Générales, ' +
        'du document d’information sur le produit d’assurance ainsi que de la fiche ' +
        'relative à l’application de la garantie dans le temps.',
        single: true,
      },
      2: {
        field: 'issueDeclaration[2]',
        question: 'J’accepte les conditions de la proposition ' + quote.application.quoteReference +
          ' et ' +
        'déclare que les réponses qui ont servi de base à son établissement sont exactes et reconnais ' +
        'ma responsabilité dans l’omission ou l’erreur de ma part concernant les informations fournies.',
        single: true,
      },
      3: {
        field: 'issueDeclaration[3]',
        question: 'Je m’engage à informer l’Assureur en cas de survenance d’un sinistre ' +
        'qui interviendrait entre aujourd’hui et la date d’effet souhaitée ou d’une modification ' +
        'à une des réponses apportées dans le questionnaire en ligne.',
        single: true,
      },
      4: {
        field: 'issueDeclaration[4]',
        question: 'J’autorise MS Amlin Insurance SE à procéder pour mon compte à la ' +
        'télétransmission de mes données assurantielles auprès de l’ORIAS lors du ' +
        'prochain renouvellement de mon inscription auprès de cet organisme.',
        single: true,
      },
    };
    if (renewal) {
      allQuestions[2] = {
        field: 'issueDeclaration[2]',
        question: 'J’ai pris connaissance et j’accepte les conditions de renouvellement de la police ' +
          quote.application.renewingPolicyNumber + ' telles qu’elles m’ont été communiquées.',
        single: true,
      };
      allQuestions[3] = {
        field: 'issueDeclaration[3]',
        question: 'Je m’engage à informer l’Assureur en cas de survenance d’un sinistre ' +
          'qui interviendrait entre aujourd’hui et la date de renouvellement ou d’une modification ' +
          'à une des réponses apportées dans le questionnaire en ligne.',
        single: true,
      };
    }

    if (!renewal) {
      questions.push(allQuestions.startDate);
    }
    questions.push(allQuestions.paymentSchedule);
    if (!renewal) {
      questions.push(allQuestions[1]);
    }
    questions.push(allQuestions[2]);
    questions.push(allQuestions[3]);

    if ((!isUndefined(ias) && ias.included) || (!isUndefined(iobsp) && iobsp.included)) {
      questions.push(allQuestions[4]);
    }

    return questions;
  }

  private declinesOrReferrals() {
    const {declines, referrals, errors} = this.state;

    if (!declines.length && !referrals.length && !errors.length) {
      return null;
    }

    if (! declines.length && this.props.quote.application.status === QuoteStatus.REFERRAL_APPROVED) {
      return null;
    }

    return (
      <div>
        <DeclinesAndReferrals
          declines={declines}
          referrals={referrals}
          errors={errors}
          quoteReference={this.props.quote.application.quoteReference}
          renewal={this.props.renewal}
        />
        {(! declines.length && ! referrals.length && errors.length) && (
          <NavigationBar
            hasBackButton={true}
            backTo={'/informations'}
            hasNextButton={false}
          />
        )}
      </div>
    );
  }

  private isFinancialGuaranteeIncluded() {
    const { ias, iobsp } = this.props;
    if (isUndefined(ias) || isUndefined(iobsp)) {
      return false;
    }

    return ias.declaration[9] === 'true' || iobsp.declaration[5] === 'true';
  }

  private quoteDocuments() {
    const { quote, activities, ias, iobsp } = this.props;
    const availableQuote = getAvailableQuote(quote);
    const availableDocuments = availableQuote[0].scheme.documents;
    const generalConditions = 'Conditions Generales: ' + PRODUCT_NAME;
    const ipid = 'IPID: ' + PRODUCT_NAME;
    const specialConventions47 = 'Conventions Spéciales et ses Annexes 47: ' + PRODUCT_NAME;
    const specialConventions457 = 'Conventions Spéciales et ses Annexes 457: ' + PRODUCT_NAME;
    const specialConventions467 = 'Conventions Spéciales et ses Annexes 467: ' + PRODUCT_NAME;
    const specialConventions4567 = 'Conventions Spéciales et ses Annexes 4567: ' + PRODUCT_NAME;

    const documents = {
      generalConditions: availableDocuments[generalConditions].path,
      propositionAssurance: ! isUndefined(quote.extraDocuments) ? quote.extraDocuments.propositionAssurance : '',
      specialConventions: '',
      productInformation: availableDocuments[ipid].path,
    };

    // Conventions Speciales et ses Annexes – please see attached documents 4, 5 6 and 7
    // Documents 4 and 7 apply if Financial Guarantee has NOT been selected
    // If Financial Guarantee has been selected and activity is 100% IAS then documents 4, 5 and 7 apply
    // If Financial Guarantee has been selected and activity is 100% IOBSP then documents 4, 6 and 7 apply
    // If Financial Guarantee has been selected and activity is IAS and IOBSP then 4, 5, 6 and 7 apply
    if (! this.isFinancialGuaranteeIncluded()) {
      documents.specialConventions = availableDocuments[specialConventions47].path;
    } else if (ias.included && activities.intermediary.percent === '100') {
      documents.specialConventions = availableDocuments[specialConventions457].path;
    } else if (iobsp.included && activities.banking.percent === '100') {
      documents.specialConventions = availableDocuments[specialConventions467].path;
    } else if (ias.included || iobsp.included) {
      documents.specialConventions = availableDocuments[specialConventions4567].path;
    }

    return documents;
  }

  private documents() {
    const quoteDocuments = this.quoteDocuments();
    return (
      <div className="documents-box">
        <Row>
          <Col sm={12}>
            <strong>Documents à télécharger</strong>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <a
              className="btn-secondary red btn"
              href={quoteDocuments.generalConditions}
              target="_blank"
            >
              Conditions Générales
             </a>
            <a
              className="btn-secondary red btn"
              href={quoteDocuments.specialConventions}
              target="_blank"
            >
              Conventions Spéciales et ses Annexes
            </a>
            <a
              className="btn-secondary red btn"
              href={quoteDocuments.productInformation}
              target="_blank"
            >
              Document d'information sur le produit d'assurance
            </a>
            {quoteDocuments.propositionAssurance.length > 0 && (
              <span>
                <a
                  className="btn-secondary red btn"
                  href={quoteDocuments.propositionAssurance}
                  target="_blank"
                >
                  Télécharger votre proposition d'assurance
                </a>
              </span>
            )}
          </Col>
        </Row>
      </div>
    );
  }

  private saveQuoteModal() {
    if (! this.quoteDocuments().propositionAssurance) {
      return null;
    }

    return (
      <SaveQuoteModal
        quoteReference={this.props.quote.application.quoteReference}
        {...this.props}
        buttonText={'Je sauvegarde et reviendrai plus tard'}
        generalConditionsDocument={this.quoteDocuments().generalConditions}
      />
    );
  }

  public render() {
    const { handleSubmit, renderDefinition, quote, renewal } = this.props;

    const declinesOrReferrals = this.declinesOrReferrals();
    if (declinesOrReferrals) {
      return declinesOrReferrals;
    }

    const questions = this.getQuestions();
    const hasBackButton = quote.application.status === QuoteStatus.REFERRAL_APPROVED ?
      getReferralsAndDeclines(quote).enableLinkOnTabs.includes('informations') : true;

    return (
      <Form horizontal={true}
            onSubmit={handleSubmit}
            autoComplete="off">
        <div className="steps-container">
          <h3>
            Validation
          </h3>

          {this.documents()}

          <DeclarationQuestions renderDefinition={renderDefinition} questions={questions}/>

          {quote.isCalculating ? (<Loading />) : (
            this.state.gross > 0 && (
              <h4>Montant Annuel à payer TTC: <span className="red premium">{displayCurrency(this.state.gross)} €</span>
              </h4>
            )
          )}

          <NavigationBar
            hasBackButton={hasBackButton}
            backTo={'/informations'}
            {...this.props}
            nextButtonText={renewal ? 'Je souhaite renouveler et payer en ligne' :
              'Je souhaite souscrire et payer en ligne'}
            saveQuoteModal={this.saveQuoteModal()}
          />
        </div>
      </Form>
    );
  }
}

let selector;

export default flow([
  reduxForm({
    form: 'quote',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector('quote');
    return component;
  },
  connect(
    (state: IStore) => {
      const startDate = selector(state, 'startDate');
      const endDate = selector(state, 'endDate');
      const quotationTypes = selector(state, 'quotationTypes');
      const declaration = selector(state, 'declaration');
      const ias = selector(state, 'ias');
      const iobsp = selector(state, 'iobsp');
      const paymentSchedule = selector(state, 'paymentSchedule');
      const activities = selector(state, 'activities');

      return {
        startDate,
        endDate,
        quotationTypes,
        auth: state.auth,
        declaration,
        ias,
        iobsp,
        paymentSchedule,
        activities,
      };
    },
    (dispatch) => ({
      actions: {
        quote: bindActionCreators({ ...quoteActions }, dispatch),
        branding: bindActionCreators({ ...brandingActions }, dispatch),
      },
    }),
  ),
])(ValidationForm);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/Validation/index.tsx